import React from "react";
import PropTypes from 'prop-types';
import "./Footer.css";

export default function Footer({ productName, productDetail, sprint, developTeam }) {
    return (
        <div className="footer-container">
            <div className="footer-title">
                {productName}
                <div className="footer-sub-title">
                    {productDetail} - {sprint}
                </div>
            </div>

            <div className="footer-about-us">
                About Us
                <div className="footer-about-us-content">
                    {developTeam}
                </div>
                <br /><br />
            </div>
        </div>
    );
};

Footer.defaultProps = {
    productName: '',
    productDetail: '',
    sprint: '',
    developTeam: '',
};

Footer.propTypes = {
    productName: PropTypes.string,
    productDetail: PropTypes.string,
    sprint: PropTypes.string,
    developTeam: PropTypes.string,
};
